import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import Axios from 'axios'
import Pusher from "pusher-js"
import Echo from "laravel-echo"

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

Vue.prototype.$axios = Axios

Vue.use(VueRouter)
Vue.use(BootstrapVue)

// Route components.
import Home from './components/Home'
import Cart from './components/Cart'
import Shop from './components/Shop'
import Login from './components/Login'
import Orders from './components/Orders'
import Profile from './components/Profile'

// Vue router options

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.IS_AUTHENTICATED) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.IS_AUTHENTICATED) {
    next()
    return
  }
  next('/login')
}

// Vue router

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: Home, beforeEnter: ifAuthenticated },
    { path: '/cart', component: Cart, beforeEnter: ifAuthenticated },
    { path: '/shop', component: Shop, beforeEnter: ifAuthenticated },
    { path: '/orders', component: Orders, beforeEnter: ifAuthenticated },
    { path: '/profile', component: Profile, beforeEnter: ifAuthenticated },
    { path: '/login', component: Login, beforeEnter: ifNotAuthenticated }
  ]
})

import { store } from './store'

window.Pusher = Pusher
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: '0429e79e0d3130ef9ab5',
    cluster: 'ap2',
    authEndpoint: 'https://shopping.test/api/broadcasting/auth',
    auth: { headers: {Authorization: 'Bearer ' + store.state.token } },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
